import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  gridPaper: {
    height: '100%',
  },
  border: {
    border: '1px solid #E0E0E0',
    '& .MuiInput-underline:before ': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
  },
  tablerow: {
    '& .css-bsph2u-MuiTableCell-root': {
      width: '40%',
    },
  },
  container: {
    backgroundColor: '#ffffff',
    borderRadius: '4px 4px 4px 4px',
    width: '100%',
    padding: theme.spacing(1, 1, 3, 1),
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    //width: 'calc(50% - 9px)',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    '& .MuiTableCell-root': {
      width: '50%',
    },
  },
  row: {
    alignItems: 'center',
    //justifyContent: 'flex-start',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '30%',
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  textField: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  btn: {
    padding: theme.spacing(1, 3.5),
    margin: theme.spacing(2, 3, 0, 0),
    fontSize: 14,
    textTransform: 'none',
  },
  textBox: {
    marginBottom: theme.spacing(3),
    fontSize: 14,
    color: 'rgb(0 0 0 / 54%)',
  },
}));
